export const PaymentsQueryKeys = {
  CREATE_BANK_ACCOUNT_LINK: ['create-bank-account-link'],
  CREATE_AEROPAY_DEPOSIT: ['create-aeropay-deposit'],
  AEROPAY_CHALLENGE_REQUIRED: (userId: string) => ['aeropay-challenge-required', userId],
  AEROPAY_CONFIRM_USER: (userId: string) => ['aeropay-confirm-user', userId],
  GET_AEROPAY_LINKED_BANK_ACCOUNTS: (userId: string) => ['aeropay-linked-bank-accounts', userId],
};
